import { Box, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import DashboardWidgetCard from '../../Dashboard/DashboardWidgetCard';
import StatRow from './StatRow';

const formatRate = value => (value == null ? '—' : `${value} %`);

// Funnel KPIs from the e-mail marketing concept (section 11): double-opt-in
// rates, cross-booking rate and voucher redemption per flow with the concept's
// target values.
export default function FunnelKpisWidget({ kpis, loading, error, onRetry }) {
  return (
    <DashboardWidgetCard
      title='Funnel-KPIs (Konzept)'
      icon='TrendingUp'
      accent='success'
      loading={loading}
      error={error}
      onRetry={onRetry}
    >
      <Stack spacing={1} sx={{ flexGrow: 1 }}>
        <StatRow
          label='Double-Opt-in-Rate Newsletter (Ziel ≥ 60 %)'
          value={formatRate(kpis?.doiRates?.newsletter)}
        />
        <StatRow
          label='Double-Opt-in-Rate Geburtstag (Ziel ≥ 60 %)'
          value={formatRate(kpis?.doiRates?.birthday)}
        />
        <StatRow
          label='Cross-Booking-Rate (Ziel ≥ 5 %)'
          value={formatRate(kpis?.crossBooking?.crossBookingRate)}
        />
        {(kpis?.flows || []).length > 0 && (
          <Box sx={{ overflowX: 'auto' }}>
            <Typography variant='caption' sx={{ fontWeight: 600, display: 'block', mt: 1 }}>
              Gutscheine, Conversion & Umsatz je Flow
            </Typography>
            <Table size='small'>
              <TableHead>
                <TableRow>
                  <TableCell>Flow</TableCell>
                  <TableCell align='right'>Kontakte</TableCell>
                  <TableCell align='right'>Gutscheine</TableCell>
                  <TableCell align='right'>Einlösequote</TableCell>
                  <TableCell align='right'>Conversion</TableCell>
                  <TableCell align='right'>Umsatz (€)</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {kpis.flows.map(flow => (
                  <TableRow key={flow.flowId}>
                    <TableCell>
                      {flow.name}
                      {flow.abTests &&
                        Object.entries(flow.abTests).map(([blockId, variants]) => (
                          <Typography
                            key={blockId}
                            variant='caption'
                            color='text.secondary'
                            sx={{ display: 'block' }}
                          >
                            A/B „{blockId}“:{' '}
                            {['A', 'B']
                              .filter(variant => variants[variant])
                              .map(
                                variant =>
                                  `${variant}: ${variants[variant].contacts} Kontakte, ` +
                                  `${formatRate(variants[variant].conversionRate)} Conv., ` +
                                  `${variants[variant].revenue} €`
                              )
                              .join(' · ')}
                          </Typography>
                        ))}
                    </TableCell>
                    <TableCell align='right'>{flow.enrollments ?? '—'}</TableCell>
                    <TableCell align='right'>
                      {flow.vouchersIssued} ({flow.vouchersIssuedValue} €)
                    </TableCell>
                    <TableCell align='right'>{formatRate(flow.redemptionRate)}</TableCell>
                    <TableCell align='right'>
                      {flow.goal ? formatRate(flow.goal.conversionRate) : '—'}
                    </TableCell>
                    <TableCell align='right'>{flow.goal ? flow.goal.revenue : '—'}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        )}
      </Stack>
    </DashboardWidgetCard>
  );
}
